module.exports = __webpack_public_path__ + "img/account.96ef061e.svg";